import { render } from "./TeamManagement.vue?vue&type=template&id=4418a5b0"
import script from "./TeamManagement.vue?vue&type=script&lang=js"
export * from "./TeamManagement.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__